import { FormField } from '@/components/ui/form-field'
import { Input } from '@/components/ui/input'
import { NativeSelect } from '@/components/ui/native-select'
import type { FollowUp, ScheduleKind, UnitKind } from '../types'

const SCHEDULES: { value: ScheduleKind; label: string }[] = [
  { value: 'geen', label: 'Geen opvolging' },
  { value: 'eenmalig', label: 'Eenmalig' },
  { value: 'terugkerend', label: 'Terugkerend' },
  { value: 'contactritme', label: 'Contactritme' },
]
const UNITS: { value: UnitKind; label: string }[] = [
  { value: 'week', label: 'weken' },
  { value: 'maand', label: 'maanden' },
  { value: 'jaar', label: 'jaar' },
]

/** The "Opvolging" fields of an agreement, compact. `unchanged` adds the choice to leave it as it is. */
export function FollowUpFields({
  value,
  onChange,
  unchanged = false,
}: {
  value: FollowUp
  onChange: (value: FollowUp) => void
  unchanged?: boolean
}) {
  const schedule = value.schedule ?? ''
  const rhythm = schedule === 'terugkerend' || schedule === 'contactritme'
  const dated = schedule === 'eenmalig' || schedule === 'terugkerend'
  return (
    <div className="space-y-3">
      <FormField label="Opvolging">
        <NativeSelect
          value={schedule}
          onChange={(event) => {
            const next = event.target.value as ScheduleKind | ''
            onChange(next ? { ...value, schedule: next } : {})
          }}
        >
          {unchanged ? <option value="">Niet wijzigen</option> : null}
          {SCHEDULES.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </NativeSelect>
      </FormField>
      {rhythm ? (
        <div className="grid grid-cols-2 gap-3">
          <FormField label="Elke">
            <Input
              type="number"
              min={1}
              max={99}
              value={value.interval_count ?? ''}
              onChange={(event) => onChange({ ...value, interval_count: event.target.value ? Number(event.target.value) : null })}
            />
          </FormField>
          <FormField label="Eenheid">
            <NativeSelect
              value={value.interval_unit ?? 'maand'}
              onChange={(event) => onChange({ ...value, interval_unit: event.target.value as UnitKind })}
            >
              {UNITS.map((unit) => (
                <option key={unit.value} value={unit.value}>
                  {unit.label}
                </option>
              ))}
            </NativeSelect>
          </FormField>
        </div>
      ) : null}
      {dated ? (
        <FormField label={schedule === 'eenmalig' ? 'Deadline' : 'Eerste deadline'}>
          <Input
            type="date"
            value={value.first_due_on ?? ''}
            onChange={(event) => onChange({ ...value, first_due_on: event.target.value || null })}
          />
        </FormField>
      ) : null}
    </div>
  )
}
